export default "__VITE_ASSET__BoUzy3Zr__"